import React, { memo, useEffect } from 'react'

declare global {
  interface Window {
    gtag: any
  }
}

export interface Props {
  author?: string
  title?: string
  description?: string
  isArticle?: boolean
  imageURL?: string
  keywords?: string
  languagePrefix?: string
  url?: string
}

export const SEO = memo(function SEO({
  author,
  title,
  description,
  isArticle,
  imageURL,
  keywords,
  languagePrefix,
  url,
}: Props) {
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('set', 'page_path', window.location.pathname)
      window.gtag('event', 'page_view')
    }
  }, [])

  return (
    <>
      {languagePrefix ? <html lang={languagePrefix} /> : null}

      {typeof window !== 'undefined' && process.env.COOKIEBOT_ID ? (
        <script
          id="Cookiebot"
          src="https://consent.cookiebot.com/uc.js"
          data-cbid={process.env.COOKIEBOT_ID}
          data-culture={languagePrefix || 'en'}
          data-blockingmode="auto"
          type="text/javascript"
        />
      ) : null}

      {title !== undefined ? (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta name="twitter:title" content={title} />
        </>
      ) : null}

      {description !== undefined ? (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </>
      ) : null}

      {keywords !== undefined ? (
        <meta name="keywords" content={keywords} />
      ) : null}

      {isArticle ? <meta property="og:type" content="article" /> : null}

      {imageURL !== undefined ? (
        <>
          <meta name="image" content={imageURL} />
          <meta property="og:image" content={imageURL} />
          <meta name="twitter:image" content={imageURL} />
          <meta name="twitter:card" content="summary_large_image" />
        </>
      ) : null}

      {author !== undefined ? (
        <meta name="author" content={author}></meta>
      ) : null}

      {url !== undefined ? <meta property="og:url" content={url} /> : null}

      <meta name="robots" content="max-image-preview:large" />
    </>
  )
})
